// src/components/CueONProductDetail.jsx

import React, { useState } from "react";
import "../assets/css/AgeretProductDetail.css";
import mainImage from "../assets/images/New-Products/new/CueON.jpeg";
import thumb1 from "../assets/images/New-Products/new/CueON.jpeg";
import howToUseThumb from "../assets/images/skin-breadcrum.jpg";
import howToUseVideo from "../assets/Video/meical video.mp4";
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";

const AgeretProductDetails = () => {
  const [selectedImage, setSelectedImage] = useState(mainImage);
  const [activeTab, setActiveTab] = useState("ingredients");
  const [showVideo, setShowVideo] = useState(false);

  return (
    <>

      <BreadcrumbSection
        title="Empowering Confidence Through Skin Health."
        // subtitle="Committed to Excellence:"
        breadcrumbItems={[
          { label: "Home", to: "/" }, { label: "Skin Care", to: "/Skin-Care-Products" },

        ]}
        backgroundImage={BredcrumpImage}
      />

      <section className="product-details-section">

        <div className="container product-container">
          {/* Product Image and Details */}
          <div className="product-info">
            <div className="product-image-section">
              <img src={selectedImage} alt="Ageret Product" className="main-image" />
              <div className="thumbnail-row">
                {[thumb1].map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`Thumbnail ${i + 1}`}
                    className={`thumbnail ${selectedImage === img ? "active-thumb" : ""}`}
                    onClick={() => setSelectedImage(img)}
                  />
                ))}
              </div>
            </div>

            <div className="product-description">
              <h2>CueON </h2>
              <p className="sub-heading text-muted">Potent Effective Steroid for treatment of Moderate to Severe Plaque Psoriasis.</p>
              <h5>Product Overview</h5>
              <p>
                A scientifically designed oral nutraceutical for comprehensive skin health, Cue-ON works from within to manage key pathological mechanisms involved in Vitiligo and Psoriasis. These chronic conditions are driven by oxidative stress, inflammation, and immune-mediated damage to melanocytes and skin cells.
                Cue-ON targets this triad by promoting melanogenesis, reducing inflammation, and controlling oxidative stress. Beyond physical symptoms, these conditions also impact patients psychologically, making effective and sustained therapy essential for improved quality of life.

              </p>
            </div>
          </div>

          {/* How To Use Section */}
          {/* <div className="how-to-use-section" data-aos="fade-up">
            <div
              className="how-to-use-content"
              style={{
                backgroundImage: `url(${howToUseThumb})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="text-content">
                <h3>
                  How To Use <span className="highlight">CueON ?</span>
                </h3>
                <p>
                  Take 1 tablet twice daily, preferably after meals or as directed by your physician. For optimal results, continue the therapy for a minimum of 8 weeks.
                </p>
              </div>
              <div className="video-thumbnail-wrapper" onClick={() => setShowVideo(true)}>
                <div className="video-thumbnail">
                  <i className="bi bi-play-fill play-icon"></i>
                </div>
              </div>
            </div>
          </div> */}

          {/* Video Popup Modal */}
          {showVideo && (
            <div className="video-popup">
              <div className="video-container">
                <video controls autoPlay>
                  <source src={howToUseVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                {/* Uncomment this block to use YouTube later */}
                {/*
              <iframe
                src="https://www.youtube.com/embed/VIDEO_ID?autoplay=1"
                title="How to Use Ageret"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              ></iframe>
              */}

                <button className="close-btn" onClick={() => setShowVideo(false)}>
                  &times;
                </button>
              </div>
            </div>
          )}

          {/* Accordion Section */}
          <div className="accordion-section">
            <div className="accordion-tabs">
              {["benefits", "ingredients", "application"].map((tab) => (
                <button
                  key={tab}
                  className={`accordion-tab ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === "benefits"
                    ? "BENEFITS"
                    : tab === "application"
                      ? "APPLICATION GUIDELINES"
                      : tab === "ingredients"
                        ? "INGREDIENTS"
                        : "BEFORE–AFTER"}
                </button>
              ))}
            </div>

            <div className="accordion-content">
              {activeTab === "benefits" && (
                <div className="tab-content fade-in">
                  <ul>
                    <li>Supports repigmentation in vitiligo</li>
                    <li>Helps reduce oxidative stress and melanocyte damage</li>
                    <li>Controls inflammatory pathways in psoriasis</li>
                    <li>Enhances skin barrier function and resilience</li>
                    <li>Reduces recurrence and flare frequency</li>
                    <li>Promotes overall skin vitality and balance</li>
                  </ul>
                </div>
              )}
              {activeTab === "application" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li><strong>Recommended Dose:</strong> 1 tablet daily</li>
                      <li><strong>Duration:</strong> Minimum 8 weeks or as directed by the physician</li>
                    </ul>

                  </p>
                </div>
              )}
              {activeTab === "ingredients" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li><strong>Silymarin (280 mg):</strong> Antioxidant; protects melanocytes and reduces oxidative stress</li>
                      <li><strong>Ginkgo biloba (120 mg):</strong> Improves microcirculation, increases GSH levels, reduces inflammatory cytokines</li>
                      <li><strong>Emblica officinalis (300 mg):</strong> Natural Vitamin C source; supports pigmentation and antioxidant defence</li>
                      <li><strong>Vitamin E (10 mg):</strong> Lipid-soluble antioxidant; protects cell membranes from oxidative damage</li>
                      <li><strong>Carotenoids (30 mg):</strong> Enhance photoprotection and support skin repair mechanisms</li>
                    </ul>
                  </p>
                </div>
              )}

            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default AgeretProductDetails;
